// Action types, inspired by Jisse Reitsma's Apollo Playground
const ADD_MESSAGE = "jola/messages/ADD_MESSAGE";
const REMOVE_MESSAGE = "jola/messages/REMOVE_MESSAGE";

export default {
  ADD_MESSAGE,
  REMOVE_MESSAGE
};
